    <!-- Modal Overlay -->
    <div
      class="fixed inset-0 bg-black/50 dark:bg-black/70 flex items-center justify-center z-50 p-4"
      *ngIf="isOpen"
    >
      <div
        #modalScrollHost
        class="bg-white dark:bg-slate-800 rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
      >

        <!-- Header -->
        <div class="flex items-start justify-between px-4 pt-8 pb-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-br from-white via-orange-50 to-amber-50 dark:from-slate-800 dark:via-slate-800 dark:to-slate-900">
          <div class="flex-1">
            <!-- Título -->
            <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Abonos e Justificativas
            </h2>

            <!-- Informações do aluno e turma -->
            <div class="space-y-1">
              <div class="flex items-center gap-2">
                <lucide-icon [img]="UserIcon" [size]="14" class="text-blue-600 dark:text-blue-400"></lucide-icon>
                <p class="text-sm text-gray-600 dark:text-gray-400">
                  <span class="font-medium">Aluno(a):</span> {{ alunoNome }}
                </p>
              </div>
              <div class="flex items-center gap-2" *ngIf="turmaNome">
                <lucide-icon [img]="CalendarIcon" [size]="14" class="text-green-600 dark:text-green-400"></lucide-icon>
                <p class="text-sm text-gray-600 dark:text-gray-400">
                  <span class="font-medium">Turma:</span> {{ turmaNome }}
                </p>
              </div>
              <div class="flex items-center gap-2">
                <lucide-icon [img]="FileTextIcon" [size]="14" class="text-purple-600 dark:text-purple-400"></lucide-icon>
                <p class="text-sm text-gray-600 dark:text-gray-400">
                  <span class="font-medium">Tipo:</span> {{ tipoFrequencia === 'DIA' ? 'Faltas por dia' : 'Faltas por aula' }}
                </p>
              </div>
            </div>
          </div>
          <button
            (click)="fechar()"
            class="flex items-center justify-center w-8 h-8 ml-4 mt-1 bg-red-600 hover:bg-red-700 rounded-lg transition-colors flex-shrink-0"
            aria-label="Fechar"
          >
            <lucide-icon [img]="XIcon" [size]="16" class="text-white"></lucide-icon>
          </button>
        </div>

        <!-- Content -->
        <div class="p-4 space-y-4">

          <!-- Mensagem de Erro Global -->
          <div
            *ngIf="erroGlobal"
            class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3 flex items-start gap-2"
          >
            <lucide-icon [img]="AlertCircleIcon" [size]="20" class="text-red-600 dark:text-red-400 flex-shrink-0"></lucide-icon>
            <div class="flex-1">
              <p class="text-sm text-red-800 dark:text-red-300 font-medium">{{ erroGlobal }}</p>
            </div>
          </div>

          <!-- Informações do Período + Aviso de Faltas Restantes -->
          <div class="rounded-lg p-3 text-sm space-y-2"
               [ngClass]="{
                 'bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-300 dark:border-yellow-800': !carregandoLista && mensagemFaltasRestantes,
                 'bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800': carregandoLista || !mensagemFaltasRestantes
               }">
            <p [ngClass]="{
                 'text-yellow-900 dark:text-yellow-300': !carregandoLista && mensagemFaltasRestantes,
                 'text-blue-900 dark:text-blue-300': carregandoLista || !mensagemFaltasRestantes
               }">
              <span class="font-medium">Período:</span> {{ periodoDescricao }}
            </p>
            <p [ngClass]="{
                 'text-yellow-900 dark:text-yellow-300': !carregandoLista && mensagemFaltasRestantes,
                 'text-blue-900 dark:text-blue-300': carregandoLista || !mensagemFaltasRestantes
               }">
              <span class="font-medium">Total de Faltas:</span> {{ totalFaltas }} {{ tipoFrequencia === 'AULA' ? 'aula(s)' : 'dia(s)' }}
            </p>
            <!-- Mensagem de faltas restantes / Educação -->
            <div *ngIf="mensagemFaltasRestantes && !carregandoLista"
                 class="flex items-start gap-2 pt-1 mt-1 border-t border-yellow-300 dark:border-yellow-700">
              <lucide-icon
                [img]="faltasRestantes === 0 ? AlertTriangleIcon : InfoIcon"
                [size]="16"
                class="flex-shrink-0 mt-0.5 text-yellow-600 dark:text-yellow-400">
              </lucide-icon>
              <p class="text-yellow-800 dark:text-yellow-300">
                {{ mensagemFaltasRestantes }}
              </p>
            </div>
          </div>

          <!-- Formulário -->
          <div class="space-y-4">

            <!-- Loading Indicators -->
            <div *ngIf="salvando" class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3 flex items-center gap-3">
              <svg class="animate-spin h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span class="text-sm font-medium text-blue-800 dark:text-blue-300">Salvando {{ form.tipo === 'ABONO' ? 'abono' : 'justificativa' }}...</span>
            </div>

            <div *ngIf="excluindo" class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3 flex items-center gap-3">
              <svg class="animate-spin h-5 w-5 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span class="text-sm font-medium text-red-800 dark:text-red-300">Excluindo...</span>
            </div>

            <!-- Mensagem de Edição -->
            <div *ngIf="modoEdicao" class="rounded-lg p-3 flex items-center gap-2 bg-[#F7E7BA]">
              <lucide-icon [img]="SquarePenIcon" [size]="16" class="flex-shrink-0 text-[#7C5F0E]"></lucide-icon>
              <span class="text-sm font-medium text-[#7C5F0E]">{{ form.tipo === 'ABONO' ? 'Editando o abono' : 'Editando a justificativa' }}</span>
            </div>

            <!-- Data(s) / Aula(s) - PRIMEIRO CAMPO -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                {{ tipoFrequencia === 'AULA' ? 'Aula(s)' : 'Data(s)' }} <span class="text-red-500">*</span>
              </label>

              <!-- Mat-Select de Datas / Aulas (múltipla seleção) -->
              <mat-form-field appearance="fill" class="w-full">
                <mat-select
                  multiple
                  [value]="getFaltasMatSelectValue()"
                  (selectionChange)="onFaltasMatSelectChange($event)"
                  panelClass="abono-faltas-panel"
                  [placeholder]="tipoFrequencia === 'AULA' ? 'Selecione as aulas' : 'Selecione a(s) data(s)'"
                >
                  <mat-select-trigger>
                    {{ faltasTriggerText() }}
                  </mat-select-trigger>

                  <!-- Mensagem quando não há faltas -->
                  <mat-option *ngIf="!carregandoLista && faltasParaSelecao.length === 0" disabled>
                    Não há faltas para Abonar/Justificar!
                  </mat-option>

                  <!-- Opção: Todas as faltas -->
                  <mat-option *ngIf="faltasParaSelecao.length > 0" value="TODAS">
                    Todas as faltas (sem abono e justificativa)
                  </mat-option>

                  <!-- Datas / Aulas individuais -->
                  <mat-option
                    *ngFor="let falta of faltasParaSelecao"
                    [value]="falta.id"
                  >
                    {{ formatarFaltaParaExibicao(falta) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                {{ form.faltasDiasSelecionadas.length }} {{ tipoFrequencia === 'AULA' ? 'aula(s) selecionada(s)' : 'data(s) selecionada(s)' }}
              </p>
            </div>

            <!-- Tipo - SEGUNDO CAMPO -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Tipo <span class="text-red-500">*</span>
              </label>
              <div class="flex items-center space-x-4">
                <label [class.cursor-not-allowed]="modoEdicao" [class.opacity-60]="modoEdicao" class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="tipo"
                    value="ABONO"
                    [(ngModel)]="form.tipo"
                    (change)="onTipoChange()"
                    [disabled]="modoEdicao"
                    class="w-4 h-4 text-red-600 focus:ring-2 focus:ring-red-500"
                  />
                  <span class="ml-2 text-sm text-gray-700 dark:text-gray-300">
                    Abono
                  </span>
                </label>
                <label [class.cursor-not-allowed]="modoEdicao" [class.opacity-60]="modoEdicao" class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="tipo"
                    value="JUSTIFICATIVA"
                    [(ngModel)]="form.tipo"
                    (change)="onTipoChange()"
                    [disabled]="modoEdicao"
                    class="w-4 h-4 text-orange-600 focus:ring-2 focus:ring-orange-500"
                  />
                  <span class="ml-2 text-sm text-gray-700 dark:text-gray-300">
                    Justificativa
                  </span>
                </label>
              </div>
            </div>

            <!-- Motivo - TERCEIRO CAMPO -->
            <div>
              <label for="motivo" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Motivo <span class="text-red-500">*</span>
              </label>

              <!-- Mat-Select de Motivo -->
              <mat-form-field appearance="fill" class="w-full">
                <mat-select
                  [value]="form.motivoId"
                  (selectionChange)="onMotivoMatSelectChange($event.value)"
                  placeholder="Selecione um motivo"
                >
                  <mat-option
                    *ngFor="let motivo of motivosFiltrados"
                    [value]="motivo.id"
                  >
                    {{ motivo.descricao }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <p *ngIf="motivosFiltrados.length === 0" class="text-xs text-amber-600 dark:text-amber-400 mt-1">
                Nenhum motivo disponível para o tipo selecionado
              </p>
            </div>

            <!-- Observações -->
            <div>
              <label for="observacao" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Observações
              </label>
              <textarea
                id="observacao"
                [(ngModel)]="form.observacao"
                rows="4"
                maxlength="4000"
                placeholder="Digite observações adicionais (opcional)"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 resize-none bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500"
              ></textarea>
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1 text-right">
                {{ form.observacao.length || 0 }} / 4000
              </p>
            </div>

            <!-- Botões -->
            <div class="flex gap-2 pt-2">
              <button
                (click)="salvar()"
                [disabled]="!formularioValido() || !canSaveCurrentForm() || salvando"
                [class]="salvando
                  ? 'flex-1 px-4 py-2.5 bg-blue-400 dark:bg-blue-800 text-white rounded-md font-medium cursor-not-allowed flex items-center justify-center gap-2'
                  : (formularioValido() && canSaveCurrentForm()
                    ? 'flex-1 px-4 py-2.5 bg-blue-600 text-white hover:bg-blue-700 rounded-md font-medium transition-colors'
                    : 'flex-1 px-4 py-2.5 bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 rounded-md font-medium opacity-50 cursor-not-allowed')"
              >
                <svg *ngIf="salvando" class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                {{ salvando ? (modoEdicao ? 'Atualizando...' : 'Adicionando...') : (modoEdicao ? 'ATUALIZAR' : 'ADICIONAR') }}
              </button>

              <button
                *ngIf="modoEdicao"
                (click)="cancelarEdicao()"
                [disabled]="salvando"
                class="px-4 py-2.5 bg-gray-500 dark:bg-gray-600 text-white rounded-md font-medium hover:bg-gray-600 dark:hover:bg-gray-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                CANCELAR
              </button>
            </div>
          </div>

          <!-- Histórico -->
          <div class="border-t border-gray-200 dark:border-gray-700 pt-4">
            <div class="flex items-center gap-2 mb-3">
              <lucide-icon [img]="HistoryIcon" [size]="18" class="text-gray-600 dark:text-gray-400"></lucide-icon>
              <h3 class="text-base font-semibold text-gray-900 dark:text-white">
                Histórico
              </h3>
              <span class="ml-auto text-xs font-medium text-gray-600 dark:text-gray-400">Total:</span>
              <span class="px-2.5 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 text-xs font-medium rounded-full">
                {{ listaAbonosJustificativas.length }}
              </span>
            </div>

            <div *ngIf="carregandoLista" class="flex flex-col items-center justify-center py-8 gap-3">
              <svg class="animate-spin h-8 w-8 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Carregando histórico...</p>
            </div>

            <div *ngIf="!carregandoLista && listaAbonosJustificativas.length === 0" class="text-center py-6">
              <p class="text-sm text-gray-500 dark:text-gray-400">Não há abono ou justificativa por aqui.</p>
            </div>

            <div *ngIf="!carregandoLista && listaAbonosJustificativas.length > 0" class="space-y-2 max-h-64 overflow-y-auto">
              <div
                *ngFor="let item of listaAbonosJustificativas; trackBy: trackById"
                class="border border-gray-200 dark:border-gray-700 rounded-md p-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors cursor-pointer"
                (click)="abrirDetalhes(item)"
              >
                <!-- Conteúdo do card (ocupa 100% da largura) -->
                <div class="mb-3">
                  <div class="flex items-center gap-2 mb-1">
                    <lucide-icon
                      [img]="FileIcon"
                      [size]="14"
                      [ngClass]="{
                        'text-red-600 dark:text-red-400': item.tipo === 'ABONO',
                        'text-orange-600 dark:text-orange-400': item.tipo === 'JUSTIFICATIVA'
                      }"
                    ></lucide-icon>
                    <span
                      class="text-xs font-medium px-2 py-0.5 rounded"
                      [ngClass]="{
                        'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-400': item.tipo === 'ABONO',
                        'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-400': item.tipo === 'JUSTIFICATIVA'
                      }"
                    >
                      {{ item.tipo }}
                    </span>
                    <span class="text-xs text-gray-500 dark:text-gray-400">
                      {{ item.dataCriacao | date:'dd/MM/yyyy' }}
                    </span>
                  </div>

                  <div class="text-sm text-gray-700 dark:text-gray-300 mb-1">
                    <span class="font-medium block mb-1.5">{{ tipoFrequencia === 'AULA' ? 'Aula(s):' : 'Data(s):' }}</span>
                    <div class="flex flex-wrap gap-1.5">
                      <span
                        *ngFor="let texto of obterArrayFaltasFormatadas(item.faltas)"
                        class="inline-flex items-center px-2 py-1 text-xs font-medium rounded-md bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300">
                        {{ texto }}
                      </span>
                    </div>
                  </div>

                  <div
                    *ngIf="item.motivo"
                    class="text-sm text-gray-700 dark:text-gray-300 mb-1"
                    [title]="item.motivo.descricao"
                  >
                    <span class="font-medium">Motivo: </span><span class="break-words">{{ truncarTexto(item.motivo.descricao, 100) }}</span>
                  </div>

                  <div
                    *ngIf="item.tipo === 'JUSTIFICATIVA' && item.justificativa"
                    class="text-sm text-gray-700 dark:text-gray-300 mb-1"
                    [title]="item.justificativa"
                  >
                    <span class="font-medium">Justificativa:</span>
                    <span class="break-words">{{ truncarTexto(item.justificativa, 150) }}</span>
                  </div>

                  <div
                    *ngIf="item.observacao"
                    class="text-sm text-gray-600 dark:text-gray-400"
                    [title]="item.observacao"
                  >
                    <span class="font-medium">Obs:</span>
                    <span class="break-words">{{ truncarTexto(item.observacao, 150) }}</span>
                  </div>
                </div>

                <!-- Botões de ação no rodapé (canto inferior direito) -->
                <div class="flex justify-end gap-2 pt-2 border-t border-gray-100 dark:border-gray-700">
                  <button
                    *ngIf="canEditItem(item)"
                    (click)="editarItem(item); $event.stopPropagation()"
                    [disabled]="modoEdicao && (item.abonosJustificativasId ?? item.id) === itemEditandoId"
                    [class.opacity-50]="modoEdicao && (item.abonosJustificativasId ?? item.id) === itemEditandoId"
                    [class.cursor-not-allowed]="modoEdicao && (item.abonosJustificativasId ?? item.id) === itemEditandoId"
                    class="p-2 bg-blue-100 dark:bg-blue-900/40 hover:bg-blue-200 dark:hover:bg-blue-900/60 rounded-md transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                    title="Editar"
                  >
                    <lucide-icon [img]="Edit2Icon" [size]="16" class="text-blue-700 dark:text-blue-300"></lucide-icon>
                  </button>
                  <button
                    *ngIf="canDeleteItem(item)"
                    (click)="confirmarExclusao(item); $event.stopPropagation()"
                    class="p-2 bg-red-100 dark:bg-red-900/40 hover:bg-red-200 dark:hover:bg-red-900/60 rounded-md transition-colors shadow-sm"
                    title="Excluir"
                  >
                    <lucide-icon [img]="Trash2Icon" [size]="16" class="text-red-700 dark:text-red-300"></lucide-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Footer -->
        <div class="p-4 border-t border-gray-200 dark:border-gray-700 flex justify-end">
          <button
            (click)="fechar()"
            class="px-6 py-2 bg-red-600 dark:bg-red-700 text-white rounded-md font-medium hover:bg-red-700 dark:hover:bg-red-600 transition-colors"
          >
            FECHAR
          </button>
        </div>

      </div>
    </div>

    <!-- Dialog de Confirmação de Exclusão -->
    <div
      *ngIf="dialogConfirmacaoAberto"
      class="fixed inset-0 z-[70] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      (click)="cancelarExclusao()"
    >
      <div
        class="bg-white dark:bg-gray-800 rounded-lg shadow-2xl max-w-md w-full mx-4 animate-in fade-in zoom-in duration-200"
        (click)="$event.stopPropagation()"
      >
        <!-- Header do Dialog -->
        <div class="p-6 border-b border-gray-200 dark:border-gray-700">
          <div class="flex items-center gap-3">
            <div class="flex-shrink-0 w-12 h-12 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
              <lucide-icon
                [img]="AlertTriangleIcon"
                [size]="24"
                class="text-amber-600 dark:text-amber-400"
              ></lucide-icon>
            </div>
            <div>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                Confirmar Exclusão
              </h3>
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
                Esta ação não pode ser desfeita
              </p>
            </div>
          </div>
        </div>

        <!-- Corpo do Dialog -->
        <div class="p-6">
          <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
            Tem certeza que deseja excluir <span class="font-semibold">{{ itemParaExcluir?.tipo === 'ABONO' ? 'este abono' : 'esta justificativa' }}</span>?
          </p>
          <p class="text-sm text-gray-600 dark:text-gray-300 mt-3">
            <span class="font-medium">Data(s):</span> {{ getDataExclusaoLabel(itemParaExcluir) }}
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-2">
            As faltas associadas voltarão a ficar sem {{ itemParaExcluir?.tipo === 'ABONO' ? 'abono' : 'justificativa' }}.
          </p>
        </div>

        <!-- Footer com Botões -->
        <div class="p-6 border-t border-gray-200 dark:border-gray-700 flex gap-3 justify-end">
          <button
            (click)="cancelarExclusao()"
            [disabled]="excluindo"
            class="px-5 py-2.5 bg-gray-500 dark:bg-gray-600 text-white rounded-md font-medium hover:bg-gray-600 dark:hover:bg-gray-500 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400 dark:focus:ring-gray-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancelar
          </button>
          <button
            (click)="confirmarExclusaoFinal()"
            [disabled]="excluindo || (itemParaExcluir && !canDeleteItem(itemParaExcluir))"
            [class]="excluindo ? 'px-5 py-2.5 bg-red-400 dark:bg-red-800 text-white rounded-md font-medium cursor-not-allowed flex items-center gap-2' : 'px-5 py-2.5 bg-red-600 dark:bg-red-700 text-white rounded-md font-medium hover:bg-red-700 dark:hover:bg-red-600 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 dark:focus:ring-red-600'"
          >
            <svg *ngIf="excluindo" class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ excluindo ? 'Excluindo...' : 'Excluir' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Detalhes -->
    <app-abono-justificativa-detalhes-modal
      *ngIf="modalDetalhesAberto && itemDetalhes"
      [item]="itemDetalhes"
      [tipoFrequencia]="tipoFrequencia"
      (fechado)="fecharDetalhes()"
    ></app-abono-justificativa-detalhes-modal>
